import type { CockpitFilterConfig, KeepFilterItem } from '../models/cockpit-filter-config.model';

const MPR_ATELIER_NATURE_FILTER = `UPPER(TRIM(COALESCE(mpr_vente.nature_orv, ''))) = 'ATELIER'`;
const MPR_ATELIER_EXCLUDED_ORV_FILTER = `mpr_vente.orv_code NOT IN ('14')`;

const ATELIER_DATE_FACTURE_FILTER: KeepFilterItem = {
  key: 'mpr_vente.date_facture',
  sourceKeys: [{ type: 'join', keys: ['start_date', 'end_date'], separator: '|', dateFormat: 'DD/MM/YYYY' }],
};

const ATELIER_PERIOD_FILTERS: KeepFilterItem[] = [
  {
    key: 'start_date',
    sourceKeys: [{ type: 'split', key: 'mpr_vente.date_facture', separator: '|', index: 0, dateFormat: 'YYYY-MM-DD' }],
  },
  {
    key: 'end_date',
    sourceKeys: [{ type: 'split', key: 'mpr_vente.date_facture', separator: '|', index: 1, dateFormat: 'YYYY-MM-DD' }],
  },
];

export const ATELIER_FILTER_CONFIG: CockpitFilterConfig[] = [
  {
    path: 'atelier/ca/etat-avancement',
    defaultFilters: [],
    keepFilters: [
      {
        key: 'mpr_vente.orv_code',
        sourceKeys: ['mpr_vente_en_cours.orv_code'],
      },
      {
        key: 'mpr_vente.libelle_equipe',
        sourceKeys: ['mpr_vente_en_cours.libelle_equipe', 'productivite.equipe'],
      },
      {
        key: 'mpr_vente.type_fa',
        sourceKeys: ['mpr_vente_en_cours.type_fa'],
      },
      {
        key: 'mpr_vente.montant_brut',
        sourceKeys: ['mpr_vente_en_cours.montant_brut'],
      },
    ],
  },
  {
    path: 'atelier/ca/historique',
    defaultFilters: [],
    keepFilters: [
      {
        key: 'mpr_vente.orv_code',
        sourceKeys: ['mpr_vente_en_cours.orv_code'],
      },
      {
        key: 'mpr_vente.libelle_equipe',
        sourceKeys: ['mpr_vente_en_cours.libelle_equipe', 'productivite.equipe'],
      },
      ATELIER_DATE_FACTURE_FILTER,
      {
        key: 'mpr_vente.montant_brut',
        sourceKeys: ['mpr_vente_en_cours.montant_brut'],
      },
    ],
  },
  {
    path: 'atelier/ca/repartition-pgc',
    defaultFilters: [],
    keepFilters: [
      {
        key: 'mpr_vente.orv_code',
        sourceKeys: ['mpr_vente_en_cours.orv_code'],
      },
      {
        key: 'mpr_vente.libelle_equipe',
        sourceKeys: ['mpr_vente_en_cours.libelle_equipe', 'productivite.equipe'],
      },
      ATELIER_DATE_FACTURE_FILTER,
      {
        key: 'mpr_vente.montant_brut',
        sourceKeys: ['mpr_vente_en_cours.montant_brut'],
      },
      {
        key: 'mpr_vente.type_fa',
        sourceKeys: ['mpr_vente_en_cours.type_fa'],
      },
    ],
  },
  {
    path: 'atelier/ca/historique-ca-pieces',
    defaultFilters: [],
    keepFilters: [
      {
        key: 'mpr_vente.orv_code',
        sourceKeys: ['mpr_vente_en_cours.orv_code'],
      },
      {
        key: 'mpr_vente.libelle_equipe',
        sourceKeys: ['mpr_vente_en_cours.libelle_equipe', 'productivite.equipe'],
      },
      ATELIER_DATE_FACTURE_FILTER,
      {
        key: 'mpr_vente.montant_brut',
        sourceKeys: ['mpr_vente_en_cours.montant_brut'],
      },
    ],
  },
  {
    path: 'atelier/assurance/historique-ca-assurance',
    defaultFilters: [],
    keepFilters: [
      {
        key: 'mpr_vente.orv_code',
        sourceKeys: ['mpr_vente_en_cours.orv_code'],
      },
      {
        key: 'mpr_vente.libelle_equipe',
        sourceKeys: ['mpr_vente_en_cours.libelle_equipe', 'productivite.equipe'],
      },
      ATELIER_DATE_FACTURE_FILTER,
    ],
  },
  {
    path: 'atelier/assurance/historique-entree-assurance',
    defaultFilters: [],
    keepFilters: [
      {
        key: 'mpr_vente.orv_code',
        sourceKeys: ['mpr_vente_en_cours.orv_code'],
      },
      {
        key: 'mpr_vente.libelle_equipe',
        sourceKeys: ['mpr_vente_en_cours.libelle_equipe', 'productivite.equipe'],
      },
      ATELIER_DATE_FACTURE_FILTER,
    ],
  },
  {
    path: 'atelier/remises/remise-hors-forfait',
    defaultFilters: [],
    keepFilters: [
      {
        key: 'mpr_vente.type_fa',
        sourceKeys: ['mpr_vente_en_cours.type_fa'],
      },
      ATELIER_DATE_FACTURE_FILTER,
    ],
  },
  {
    path: 'atelier/remises/remise-forfait',
    defaultFilters: [],
    keepFilters: [
      {
        key: 'mpr_vente.type_fa',
        sourceKeys: ['mpr_vente_en_cours.type_fa'],
      },
      ATELIER_DATE_FACTURE_FILTER,
    ],
  },
  {
    path: 'atelier/remises/remise-pr-hors-forfait',
    defaultFilters: [],
    keepFilters: [ATELIER_DATE_FACTURE_FILTER],
  },
  {
    path: 'atelier/remises/remise-pr-forfait',
    defaultFilters: [],
    keepFilters: [ATELIER_DATE_FACTURE_FILTER],
  },
  {
    path: 'atelier/entree/historique-pgc',
    defaultFilters: [],
    keepFilters: [
      {
        key: 'mpr_vente.orv_code',
        sourceKeys: ['mpr_vente_en_cours.orv_code'],
      },
      {
        key: 'mpr_vente.libelle_equipe',
        sourceKeys: ['mpr_vente_en_cours.libelle_equipe', 'productivite.equipe'],
      },
      {
        key: 'mpr_vente.type_fa',
        sourceKeys: ['mpr_vente_en_cours.type_fa'],
      },
    ],
  },
  {
    path: 'atelier/entree/repartition-pgc',
    defaultFilters: [],
    keepFilters: [ATELIER_DATE_FACTURE_FILTER],
  },
  {
    path: 'atelier/en-cours/encours-60-j',
    defaultFilters: [],
    keepFilters: [
      {
        key: 'mpr_vente_en_cours.orv_code',
        sourceKeys: ['mpr_vente.orv_code'],
      },
      {
        key: 'mpr_vente_en_cours.libelle_equipe',
        sourceKeys: ['mpr_vente.libelle_equipe', 'productivite.equipe'],
      },
      {
        key: 'mpr_vente_en_cours.type_fa',
        sourceKeys: ['mpr_vente.type_fa'],
      },
      {
        key: 'mpr_vente_en_cours.montant_brut',
        sourceKeys: ['mpr_vente.montant_brut'],
      },
    ],
  },
  {
    path: 'atelier/ratio-perf/panier-moyen',
    defaultFilters: [],
    keepFilters: [
      {
        key: 'mpr_vente.orv_code',
        sourceKeys: ['mpr_vente_en_cours.orv_code'],
      },
      {
        key: 'mpr_vente.libelle_equipe',
        sourceKeys: ['mpr_vente_en_cours.libelle_equipe', 'productivite.equipe'],
      },
      {
        key: 'mpr_vente.type_fa',
        sourceKeys: ['mpr_vente_en_cours.type_fa'],
      },
      {
        key: 'mpr_vente.montant_brut',
        sourceKeys: ['mpr_vente_en_cours.montant_brut'],
      },
      ATELIER_DATE_FACTURE_FILTER,
    ],
  },
  {
    path: 'atelier/ratio-perf/pneu-equipe',
    defaultFilters: [],
    keepFilters: [
      {
        key: 'mpr_vente.orv_code',
        sourceKeys: ['mpr_vente_en_cours.orv_code'],
      },
      {
        key: 'mpr_vente.libelle_equipe',
        sourceKeys: ['mpr_vente_en_cours.libelle_equipe', 'productivite.equipe'],
      },
      {
        key: 'mpr_vente.type_fa',
        sourceKeys: ['mpr_vente_en_cours.type_fa'],
      },
      ATELIER_DATE_FACTURE_FILTER,
    ],
  },
  {
    path: 'atelier/productivite/globale',
    defaultFilters: [{ key: 'start_date' }, { key: 'end_date' }],
    keepFilters: [
      ...ATELIER_PERIOD_FILTERS,
      {
        key: 'productivite.equipe',
        sourceKeys: ['mpr_vente_en_cours.libelle_equipe', 'mpr_vente.libelle_equipe'],
      },
    ],
  },
  {
    path: 'atelier/productivite/par-compagnon',
    defaultFilters: [{ key: 'start_date' }, { key: 'end_date' }],
    keepFilters: [
      ...ATELIER_PERIOD_FILTERS,
      {
        key: 'productivite.equipe',
        sourceKeys: ['mpr_vente_en_cours.libelle_equipe', 'mpr_vente.libelle_equipe'],
      },
    ],
  },
  {
    path: 'atelier/achat-cession-atelier',
    defaultFilters: [{ key: 'start_date' }, { key: 'end_date' }],
    keepFilters: [
      ...ATELIER_PERIOD_FILTERS,
      {
        key: 'mpr_vente.type_fa',
        sourceKeys: ['mpr_vente_en_cours.type_fa'],
      },
      {
        key: 'mpr_vente.orv_code',
        sourceKeys: ['mpr_vente_en_cours.orv_code'],
      },
      {
        key: 'mpr_vente.libelle_equipe',
        sourceKeys: ['mpr_vente_en_cours.libelle_equipe', 'productivite.equipe'],
      },
      {
        key: 'mpr_vente.montant_brut',
        sourceKeys: ['mpr_vente_en_cours.montant_brut'],
      },
    ],
  },
  {
    path: 'atelier/refacturation-a-client-sur-or',
    defaultFilters: [],
    keepFilters: [
      ATELIER_DATE_FACTURE_FILTER,
      {
        key: 'mpr_vente.montant_brut',
        sourceKeys: ['mpr_vente_en_cours.montant_brut'],
      },
    ],
  },
];

export function buildMprFilterWhere(...conditions: string[]): string {
  return conditions.filter(Boolean).join(' AND ');
}

export function buildAtelierMprFilterWhere(...conditions: string[]): string {
  return buildMprFilterWhere(MPR_ATELIER_NATURE_FILTER, MPR_ATELIER_EXCLUDED_ORV_FILTER, ...conditions);
}

export function buildAssuranceMprFilterWhere(...conditions: string[]): string {
  return buildMprFilterWhere(
    MPR_ATELIER_EXCLUDED_ORV_FILTER,
    `EXISTS (
      SELECT 1 FROM gps.regroupement_assurance assurance_filter
      WHERE assurance_filter.num_compte = mpr_vente.num_client::text
        AND assurance_filter.id_affaire = mpr_vente.id_affaire
        AND assurance_filter.id_point_relais IS NOT DISTINCT FROM mpr_vente.id_point_relais
    )`,
    ...conditions,
  );
}
